import { TemplateBackstageLogoIcon } from '@backstage/plugin-home';
import AcUnitIcon from '@material-ui/icons/AcUnit';

export const tools = [
  {
    url: '/legacy-lineage',
    label: 'Legacy Lineage',
    icon: <AcUnitIcon />,
  },
  {
    url: '/dr-event-taxonomy-reference-data',
    label: 'Event Taxonomy Reference Data',
    icon: <TemplateBackstageLogoIcon />,
  },
];
